export default {
    common: {
        email: 'E-Mail',
        LoginBtn: 'Sich einloggen',
        SignUpBtn: 'Registrieren',
        SubmitBtn: 'Bestätigen',
        ExitBtn: 'Verlassen',
        LogoutBtn: 'Abmelden'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Bitte überprüfen Sie Ihre E-Mail auf den Verifizierungscode.',
        VerificationCode: 'Verifizierungscode'
    },
    header: {
        OrderHistory: 'Verlauf der Bestellungen',
        MYACCOUNT: 'MEIN KONTO',
        WelcomeBack: 'Willkommen'
    },
    detail: {
        TotalOrders: 'Gesamtanzahl der Bestellungen',
        TotalProducts: 'Gesamtanzahl der Produkte',
        WonderlandPoints: 'Wonderland-Punkte',
        APMCredits: 'APM Credits',
        ExpireOn: 'Ablaufen bei',
        NoAPMCredits: 'Keine APM-Credits',
        CreditsLoading: 'Credits laden',
        Orders: 'Bestellung',
        Online: 'Online',
        Boutique: 'Boutique',
        Total: 'Gesamt',
        Delivered: 'Zugestellt',
        NoData: 'Keine Daten',
        Status: 'Status',
        item: 'Artikel',
        items: 'Artikel'
    },
    panel: {},
    entry: {
        Client: 'Kunde',
        OrderDate: 'Datum der Bestellung',
        DeliverDate: 'Datum der Lieferung',
        Description: 'Beschreibung',
        Total: 'Gesamt'
    },
    board: {
        Order: 'BESTELLUNG',
        Date: 'DATUM',
        Total: 'TOTAL'
    },
    order: {
        OrderID: 'ID Bestellung',
        PurchasePlace: 'Ort',
        PurchaseDate: 'Datum der Bestellung',
        TotalPrice: 'Preis Gesamt',
    },
    product: {
        Name: 'Name',
        SKU: 'SKU',
        Size: 'Größe',
        Quantity: 'Menge',
        Price: 'Preis',
        WarrantyUntil: 'Garantie bis',
    },
    ordersLayout: {
            pageTitleOrders: "Bestellungen",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "Startseite",
            navProfile: "Profil",
            navOrders: "Bestellungen",
            navWonderland: "Wonderland",
            navWishlist: "Wunschliste",
            navContactUs: "Kontakt",
            navExchangeReturn: "Umtausch & Rückgabe",
            footerExchangePolicy: "Richtlinie zu Umtausch & Rückgabe",
            footerShipping: "Versand",
            footerPrivacy: "Datenschutz",
            footerTerms: "Nutzungsbedingungen",
            footerRegion: "Frankreich",
            menuTrackOrder: "Bestellung verfolgen",
            menuViewDetails: "Details anzeigen",
            back: "Zurück",
            orderNumberHeading: "Bestellnummer {{id}}",
            itemsCount_one: "{{count}} Artikel",
            itemsCount_other: "{{count}} Artikel",
            emptyOrders: "Sie haben noch keine Bestellungen.",
            loading: "Wird geladen",
            invoiceSoon: "Demnächst",
            storeAddressPending: "Adresse folgt",
            skuPrefix: "SKU",
            statusLabel: "Status",
            productNameFallback: "Artikel",
            tabOnline: "ONLINE",
            tabOffline: "OFFLINE",
            learnMore: "MEHR ERFAHREN",
            redeemInStore: "IM GESCHÄFT EINLÖSEN",
            dateLabel: "Datum",
            itemSingular: "Artikel",
            statusConfirmed: "Bestätigt am",
            purchaseDateLabel: "Kaufdatum:",
            monthJan: "Jan",
            monthFeb: "Feb",
            monthMar: "Mär",
            monthApr: "Apr",
            monthMay: "Mai",
            monthJun: "Jun",
            monthJul: "Jul",
            monthAug: "Aug",
            monthSep: "Sep",
            monthOct: "Okt",
            monthNov: "Nov",
            monthDec: "Dez",
            storeLabel: "Boutique",
            downloadInvoice: "Rechnung herunterladen",
            warrantyExpires: "Garantie läuft ab am",
            sizeLabel: "Größe",
            subtotalLabel: "Zwischensumme",
            totalLabel: "Gesamt",
            ecListTitle: "Ihre Bestellungen",
            ecStatusInStore: "Status: Kauf in der Boutique",
            ecOrderNumber: "Bestellnummer: {{order_number}}",
            ecDateStore: "{{date}} · {{store_name}}",
            ecCountTotalOne: "{{count}} Artikel: Gesamt {{amount}}",
            ecCountTotalOther: "{{count}} Artikel: Gesamt {{amount}}",
            ecViewOrder: "Bestellung ansehen >",
            ecViewOrderA11y: "Bestellung {{order_number}} ansehen",
            ecBackToOrders: "Zurück zu Ihren Bestellungen",
            ecInStoreDate: "Kauf in der Boutique – {{date}}",
            ecProductsOne: "Produkt",
            ecProductsOther: "Produkte",
            ecSku: "Art.-Nr. {{sku}}",
            ecQty: "Menge: {{qty}}",
            ecWarrantyExpired: "Garantie abgelaufen",
            ecWarrantyActive: "Garantie gültig",
            ecSubtotalOne: "Zwischensumme – {{count}} Artikel",
            ecSubtotalOther: "Zwischensumme – {{count}} Artikel",
        },
}



// WEBPACK FOOTER //
// ./src/locales/ge/index.js